<script setup lang="ts">
import { computed, ref, type Ref } from 'vue';

import { useAuthStore, useCommunityStore } from '@/stores';
import { currentLocale } from '@/plugins/i18n';
import { useCommunityMenu } from '@/composables/useCommunityMenu';

const authStore = useAuthStore();
const communityStore = useCommunityStore();

const props = defineProps<{
  userName: string;
}>();

const showOrganizationSwitcher = ref(false);
const selectedOrganization: Ref<any | null> = ref(null);
// Headers are disabled options, so the select keeps customers and demos apart.
const entries = useCommunityMenu();
const organizations = computed(() =>
  entries.value.map((entry) =>
    entry.header
      ? { label: entry.label, value: entry.key, header: true, disable: true }
      : { label: entry.label, value: entry.community, caption: entry.caption },
  ),
);

const onShowOrganizationSwitcher = () => {
  selectedOrganization.value = communityStore.communities.find((c) => c.id === authStore.currentCommunity);
};

const goToProfile = () => {
  // Implement navigation to the user profile
};

const switchOrganization = async (evt: Event) => {
  evt.preventDefault();
  await communityStore.switchCommunity(selectedOrganization.value, true);
};

const logout = () => {
  authStore.logout();
};

function availableLocale() {
  return currentLocale() === 'en' ? 'fr' : 'en';
}
</script>

<template>
  <q-btn flat>
    <!--<q-avatar>
                <img :src="props.userProfilePic" alt="user" />
            </q-avatar>-->
    {{ props.userName }}
    <q-menu>
      <q-list>
        <q-item clickable v-close-popup @click="authStore.chooseLocale(availableLocale())">
          <q-item-section>{{ availableLocale().toLocaleUpperCase() }}</q-item-section>
        </q-item>
        <q-separator />
        <q-item clickable v-close-popup @click="showOrganizationSwitcher = true">
          <q-item-section>{{ $t('profile.change-community') }}</q-item-section>
        </q-item>
        <q-separator />
        <q-item clickable v-close-popup @click="logout">
          <q-item-section>{{ $t('profile.logout') }}</q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </q-btn>

  <q-dialog v-model="showOrganizationSwitcher" @before-show="onShowOrganizationSwitcher">
    <q-card>
      <q-card-section>
        <div class="text-h6">{{ $t('profile.change-community') }}</div>
      </q-card-section>
      <q-card-section>
        <q-select
          v-model="selectedOrganization"
          :options="organizations"
          label="Choisir une communauté"
          emit-value
          map-options
          @input="switchOrganization"
        >
          <template v-slot:option="scope">
            <q-item-label v-if="scope.opt.header" header>{{ scope.opt.label }}</q-item-label>
            <q-item v-else v-bind="scope.itemProps">
              <q-item-section>
                <q-item-label>{{ scope.opt.label }}</q-item-label>
                <q-item-label v-if="scope.opt.caption" caption>{{ scope.opt.caption }}</q-item-label>
              </q-item-section>
            </q-item>
          </template>
        </q-select>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn flat label="Annuler" color="primary" v-close-popup />
        <q-btn label="Valider" @click="switchOrganization" flat color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
